var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_18640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02648 6.00915L11.3875 1.64796C11.6714 1.36428 11.6714 0.905615 11.3875 0.621938C11.1039 0.33826 10.6452 0.33826 10.3615 0.621938L6.00033 4.98313L1.63927 0.621938C1.35546 0.33826 0.896926 0.33826 0.613248 0.621938C0.329438 0.905615 0.329438 1.36428 0.613248 1.64796L4.97431 6.00915L0.613248 10.3703C0.329438 10.654 0.329438 11.1127 0.613248 11.3964C0.754622 11.5379 0.940507 11.609 1.12626 11.609C1.31201 11.609 1.49776 11.5379 1.63927 11.3964L6.00033 7.03517L10.3615 11.3964C10.503 11.5379 10.6888 11.609 10.8745 11.609C11.0603 11.609 11.246 11.5379 11.3875 11.3964C11.6714 11.1127 11.6714 10.654 11.3875 10.3703L7.02648 6.00915Z",
    fill: "#382C83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_18640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "white",
    transform: "translate(0.400391 0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ef2d2d0895ea5576dfc94f4bd6cc81d6.svg";
export { ForwardRef as ReactComponent };